export default __webpack_public_path__ + "static/media/kaminfeuer_web-lg@2x.ff53fd48.jpg";